import { FC } from 'react';
import useQueryParams from 'src/hooks/useQueryParams';
import AdyenRedirectView from './AdyenRedirect';
import SubscriptionRedirectView from './SubscriptionRedirect';
const PaymentRedirectView: FC = () => {
  const {
    method
  } = useQueryParams<{
    method?: string;
  }>() || {};
  if (method === 'subscription') {
    return <SubscriptionRedirectView />;
  }
  return <AdyenRedirectView data-sentry-element="AdyenRedirectView" data-sentry-component="PaymentRedirectView" data-sentry-source-file="PaymentRedirect.tsx" />;
};
export default PaymentRedirectView;